import { shopwareApiClient } from '$lib/api/shopwareApi.js';
import type { ApiRequestParams, ApiReturnType } from '$lib/api/shopwareApi.js';
import type { ShopContext } from '$lib/context.js';

export class ContactApi {
    public static sendContactMail(
        data: ApiRequestParams<'sendContactMail'>
    ): Promise<ApiReturnType<'sendContactMail'>> {
        return shopwareApiClient.invoke('sendContactMail post /contact-form', data, {
            shopContext: { shopwareLanguage: {}, storeContext: {} } as ShopContext
        });
    }
}
